<div class="promotion-code-child-component">
  <h5>Message Setting</h5>
  <div class="promotion-code-child-component-content">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-4 mb-4">
              <span class="kt-font-bold">SMS</span>
                <kt-dropdown-wo-lazyload
                  [form] = 'form'
                  [dropdownList] = 'smsTemplateList'
                  [dropdownSettings] = 'smsTemplatesSettings'
                  [formName] = "'message_template_sms_id'"
                  [selectionAttributes] = "'id'"
                  [selectedItems] ='smsTemplateSelectedItem'
                  [dataLoading]="smsTemplateLoading">
                </kt-dropdown-wo-lazyload>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Message</span>
                <kt-dropdown-wo-lazyload
                  [form] = 'form'
                  [dropdownList] = 'messageTemplateList'
                  [dropdownSettings] = 'messageTemplatesSettings'
                  [formName] = "'message_template_id'"
                  [selectionAttributes] = "'id'"
                  [selectedItems] ='messageTemplateSelectedItem'
                  [dataLoading]="messageTemplateLoading">
                </kt-dropdown-wo-lazyload>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Dialog Popup</span>
                <kt-dropdown-wo-lazyload
                  [form]="form" 
                  [dropdownList]="popupDropdownListArray" 
                  [dropdownSettings]="popupDropdownSettings" 
                  [formName]="'dialog_popups'" 
                  [selectionAttributes]="'id'" 
                  [selectedItems]="popupSelectedItems"
                  [dataLoading]="popupLoading"
                  (selectedItemsChanged)="onSelectedPopupItems($event)"> 
                </kt-dropdown-wo-lazyload>
                <span class="reminder-text" *ngIf="checkDialogValidityDate(popupSelectedItems)">
                  <i class="fa fa-exclamation-circle promotion-code-detail-tooltip" placement="top"></i> 
                  The selected dialog popup is not within its validity period or has been expired.
                </span>
            </div>
        </div>
      </form>
  </div>
</div>